import React, { useState } from 'react';

import { makeStyles } from "@mui/styles";
import { horizontalTabStyles } from '../../sharedStyles';

import Contacts from './Contacts';

import FloatingMessage from '../../../../common/FloatingMessage';


const useStyles = makeStyles(() => ({
    catalogTab: {
        height: '100%',
        position: 'relative',
        ...horizontalTabStyles.tabWrapper,
        '& .header': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold'
        },
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    },
    tabBody: {
        ...horizontalTabStyles.tabBody,
    }
}));
const Catalog = () => {
    const classes = useStyles();
    const [error, setError] = useState('');
    const [messageType, setMessageType] = useState('error');

    return (<div className={classes.catalogTab}>
        <FloatingMessage open={error !== ""} message={error} severity={messageType} onClose={() => setError("")} />
        <div className={classes.tabBody}>
            <Contacts toggleError={(msg, type = 'error') => {
                setError(msg);
                setMessageType(type);
            }} />
        </div>
    </div>)
}
export default Catalog;